import script from "./ComponentPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponentPreview.vue?vue&type=script&setup=true&lang=js"

import "./ComponentPreview.vue?vue&type=style&index=0&id=1a0be33f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a0be33f"]])

export default __exports__